module.exports = __webpack_public_path__ + "img/tour (1).6476253c.svg";